<template>
<div>
    <div class="help_Info_right fr">
        <div class="help_Info_right_top fl">
            配送答疑
        </div>
        <div class="help_Info_right_bootm shoppstep fl">
            <dl>
                <dt>配送答疑</dt>
                <dd>1) 关于物流信息：直接查物流单号即可，或咨询西始客服帮忙查询；</dd>
                <dd>2) 关于丢件处理：若快递告知丢件，客户可立即联系西始售后人员为您处理；</dd>
                <dd>3) 关于包装破损：收货时发现外包装破损、变形等情况时，客户应当场开箱检查，确认货物完好后再签收，或直接拒签；</dd>
                <dd>4) 关于物流签收：若物流信息显示签收，但客户并没有收到货物，可先与配送人员联系，查看是否配送操作失误，或已由他人代收，如确认没有收到货，可联系西始客服查询原因；</dd>
                <dd>5) 关于货物少件：同一订单购买多个商品可能会分为一个以上包裹发出，可能不会同时送达，如确认未收到，可及时联系西始客服。</dd>
            </dl>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "answer"
};
</script>

<style>

</style>
